import intermind from '../../../index';

export class GoogleResource {
  async authUrl(): Promise<string> {
    const { data } = await intermind.httpClient.get<string>('/calendar/google/auth/url');
    return data;
  }

  async authCallback(code: string): Promise<void> {
    await intermind.httpClient.post('/calendar/google/auth/callback', { code });
  }

  async sync(): Promise<void> {
    await intermind.httpClient.post('/calendar/google/sync');
  }
}
